import { keepPreviousData, useQuery } from '@tanstack/react-query'

import type { GetAirportsByNameQueryResponse } from '../../types/index.js'

import { apiClient } from '../../lib/client.js'
import { airportKeys } from './keys.js'

export interface UseGetAirportsByNameQueryParams {
  filter?: 'active' | 'all' | 'inactive'
  fuzzy: string
  take?: number
}

export const useGetAirportsByNameQuery = (params: UseGetAirportsByNameQueryParams) =>
  useQuery({
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const response = await apiClient.client.get<GetAirportsByNameQueryResponse>(
        '/airport/search-by-city',
        {
          params: {
            filter: params.filter,
            fuzzy: params.fuzzy,
            take: params.take === Infinity ? 'all' : params.take,
          },
        }
      )
      return response.data
    },
    queryKey: airportKeys.list(params),
  })
